import React from 'react';
import Modal from 'chameleon/ui-stack/ui/base/modal';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Button from 'chameleon/ui-stack/ui/base/button';
import { withRouter } from 'react-router';

import './styles.scss';

const GeneratePracticeQuizSuccessModal = (props) => {
  const { isVisible, setCreateQuizSuccessData, itemId, router, params } = props;
  const handleEditQuiz = () => {
    router.push(
      `/${params.subject}/question_bank/create?editMode=true&quizId=${itemId}`,
    );
  };
  const handleClose = () => {
    setCreateQuizSuccessData({
      isModalVisible: false,
      itemId: '',
    });
  };
  const renderButtonContent = () => {
    return (
      <div className="flex justify-end items-center border-t border-gray-300 h-32 pr-3">
        <Button isNaked onClick={() => handleClose()}>
          Close
        </Button>
        <Button isPrimary onClick={() => handleEditQuiz()}>
          Edit Quiz
        </Button>
      </div>
    );
  };
  return (
    isVisible && (
      <Modal
        onClose={() => handleClose()}
        title="Generate Practice Quiz"
        bottomContent={renderButtonContent()}
        dialogClassName="modal-container"
      >
        <div className="flex items-center gap-x-2">
          <Icon
            accessibility={{
              ariaHidden: true,
            }}
            id="my-quiz"
            width="64"
            height="64"
          />
          <div className="content-text-wrapper">
            Your practice quiz has been successfully generated.
            <span>
              You can go to Edit Quiz page to preview and make edits to this
              quiz
            </span>
          </div>
        </div>
      </Modal>
    )
  );
};

export default withRouter(GeneratePracticeQuizSuccessModal);
